import styled from 'styled-components';

export const ResultsContainer = styled.div`
	padding: 3rem;
	background-color: white;
	border-radius: 0.5rem;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);
	height: 100%;
`;
